import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getAuth } from '@angular/fire/auth';
import { NGXLoggerServerService } from 'ngx-logger';
import { Observable, firstValueFrom, from, map, of } from 'rxjs';

@Injectable()
export class AuthTokenServerService extends NGXLoggerServerService {
  protected override alterHttpRequest(
    httpRequest: HttpRequest<any>
  ): Observable<HttpRequest<any>> {
    const ptoken = getAuth().currentUser?.getIdToken();
    if (ptoken) {
      return from(ptoken).pipe(
        map((token) => {
          httpRequest = httpRequest.clone({
            setHeaders: {
              ['Authorization']: `Bearer ${token}`,
            },
          });
          return httpRequest;
        })
      );
    } else {
      return of(httpRequest);
    }
  }
}
